<template>
  <div style="height: 100%" class="pa-4">
    <v-row justify="space-between" class="mb-4">
      <v-col v-if="!noHeader">
        <div class="font-weight-bold basic--text text-center">
          {{ "Scratch Card Details".toUpperCase() }}
        </div>
      </v-col>
    </v-row>

    <v-form ref="form" v-model="dataValid">
      <v-alert type="info" class="mt-4">
        Scratch card purchase {{hasScratchCards ? 'made' : 'required'}}. Reload this page few seconds after payments
      </v-alert>
      <v-sheet outlined rounded  v-for="item in getSSCEDetails" :key="item.id" class="mb-2">
        <div class="d-flex justify-space-between py-2">
          <div class="my-auto ml-4">
            {{item.examType.title}}
          </div>
          <v-btn class="ml-auto mr-4" :disabled="item.scratchCardPin != null" depressed text color="success" @click="initializeTransaction(item.id, item.organization.id)">Purchase</v-btn>
        </div>
      </v-sheet>
    </v-form>
    <v-card-actions class="mt-6">
      <v-spacer></v-spacer>
      <v-btn color="basic" class="white--text" @click="$emit('back')" depressed>{{  noHeader ? 'Back' : 'Previous' }}</v-btn>
      <v-btn
          color="primary"
          depressed
          :disabled="!hasScratchCards"
          @click="success"
          v-if="hasScratchCards"
      >{{  noHeader ? 'Save' : 'Proceed' }}</v-btn
      >
      <v-btn
          color="info"
          depressed
          @click="success"
          v-if="hasScratchCards"
      >Skip</v-btn
      >
    </v-card-actions>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box
        :show="messageShow"
        :message="message"
        :type="messageType"
        v-on:close-message="messageShow = !messageShow"
    ></message-box>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import {PaymentGateway} from "@/shared/PaymentGateway";
import GateWays from "@/shared/GateWays";
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";

export default {
  name: "ScratchCard",
  props: {
    noHeader: Boolean
  },
  components: {MessageBox, LoadingDialog},
  data: () => ({
    dataValid: true,
    paymentGateway: null,
    paymentConfig: {},
    payment: null,
    messageType: "",
    message: "",
    messageShow: false,
    loading: false,
  }),

  methods: {
    success() {
      this.$emit("success");
    },

    initializeTransaction(ssce, org){
      this.loading = true
      let vm = this;
      Api.scratchCard.getConfig(org)
          .then(res => {
            // set config
            vm.paymentConfig = res.data.paymentPlatform
            this.paymentGateway = new PaymentGateway(GateWays.PAYSTACK, vm, undefined)
            this.paymentGateway.initializeGateway(vm.paymentConfig)
            // initialize
            Api.scratchCard.initializeTransaction({ ssceDetail: ssce})
                .then(res => {
                  vm.payment = res.data.feePayment;
                  vm.makePayment()
                }).catch(err => ErrorResolver.checkErrors(this, err))
                .finally(() => this.loading = false)
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    makePayment(){
      //console.log(this.payment)
      this.loading = true
      window.location.href = this.payment.paymentLink
    }
  },

  computed: {
    ...mapGetters(["getScratchCards", "getSSCEDetails", "getUser"]),

    hasScratchCards: function(){
      return this.getScratchCards.length === this.getSSCEDetails.length
      // return true
    }

  },

  created() {
    this.noHeader && this.$emit('update-title', "Scratch cards")
  }
}
</script>

<style scoped>

</style>
